<template>
    <div>
        <h2>Your free trial has expired; please <router-link :to="'/subscription'" target="_blank">click here</router-link> to upgrade if you'd like to continue using lighty.    After you're done, please refresh your Zoom/Google Meet webpage to use lighty.<br/>Thanks!</h2>
    </div>
</template>

<script>
export default {
	mounted: function() 
    {
        window.analytics.page('Please Upgrade');
	}
}
</script>

<style scoped>

</style>
